import React from "react"

import {
	addQueryParams,
} from "services/functions"

const ActionButton = ({text, url, queryParams, onClick}) => (
	<a
		className="action-button"
		target="_blank"
		rel="noopener noreferrer"
		onClick={typeof onClick !== "undefined" ? (e) => {
		e.preventDefault();
		onClick();
	} : null}
	href={(url || "") + (typeof queryParams !== "undefined" ? addQueryParams(queryParams) : "")}>{text}</a>
)

export default ActionButton;